import {
  pagedListWrapper,
  singleItemWrapper
} from '../../../api-client/wrappers'
import type { Starter } from '../../types/internal'
import type { Privilege } from './types'

export default {
  factory: ({ apiClient, version }) => {
    const privileges = pagedListWrapper<'id', Privilege>()(apiClient, {
      path: `/api/v${version}/privileges`,
      idKey: 'id'
    })

    const { get: getPrivilegeKeys } = singleItemWrapper<
      string[],
      any,
      any,
      { groupKey: string }
    >(apiClient, {
      path: (_query, { groupKey }) =>
        `/api/v${version}/privilege/groups/${groupKey}/keys`
    })

    return {
      privileges,
      getPrivilegeKeys,

      usePrivilege: (id: Privilege['id']) =>
        apiClient.post(`/api/v${version}/privileges/${id}/use`)
    }
  }
} satisfies Starter
